import script from "./searchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./searchPage.vue?vue&type=script&setup=true&lang=js"

import "./searchPage.vue?vue&type=style&index=0&id=6be70b3c&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be70b3c"]])

export default __exports__